import React, { useEffect, useState } from "react";
import styled from "styled-components";
import useColorThief from "use-color-thief";
import Navbar from "./components/navbar";
import TrackDetails from "./components/track-details";
import TrackPlayer from "./components/track-player";
import SocialMediaLinks from "./components/social-media-links";
import api from "services/axiosInstance";
import Toast from "components/toast";
import { useParams } from "react-router-dom";
import { IRatedFansData } from "types/ratedfansData";
import { FindArtistById } from "services/user/getUser";
import Spinner from "components/spinner";

const TrackShare = () => {
  const [loading, setLoading] = useState(false);
  const [ratedFansData, setRatedFansData] = useState<IRatedFansData>();
  const [isOwner, setIsOwner] = useState(false);
  const [preSave, setPresave] = useState(true);
  const [albumCover, setAlbumCover] = useState<string>("");

  const { id } = useParams();

  const GetData = async () => {
    if (loading) return;
    setLoading(true);
    try {
      const { data } = await api.get(`/r/${id}`);
      const ratedFansData: IRatedFansData = data.data;

      if (!ratedFansData) {
        throw new Error("Something went wrong");
      }

      setRatedFansData(ratedFansData);

      setPresave(ratedFansData.isPresaveEnabled);

      const artist = FindArtistById(ratedFansData.artist.id);
      setIsOwner(artist ? true : false);

      setAlbumCover(ratedFansData.coverArtLink.url);
    } catch (err) {
      Toast({ error: err });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    GetData();
  }, []);

  const { color, palette } = useColorThief(
    ratedFansData?.coverArtLink.url || "",
    {
      format: "hex",
      colorCount: 2,
      quality: 10
    }
  );

  if (!ratedFansData)
    return (
      <div
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh"
        }}
      >
        <Spinner width="5rem" />
      </div>
    );

  return (
    <Main>
      <BackGround colorb={palette[1] as string} colora={palette[0] as string} />
      <Container>
        <NavContainer>
          {isOwner && (
            <Navbar preSave={preSave} ratedFansData={ratedFansData} />
          )}
        </NavContainer>
        <Body>
          <TrackDetails
            albumCover={ratedFansData?.coverArtLink.url || ""}
            releaseType={ratedFansData?.releaseType || ""}
            releaseTitle={ratedFansData?.releaseTitle || ""}
            artistName={ratedFansData?.artist.name || ""}
          />
          <TrackPlayer
            preSave={true}
            links={ratedFansData?.links || []}
            previewClips={ratedFansData?.previewClips || []}
          />
          <SocialMediaLinks {...(ratedFansData?.socialMediaLinks || {})} />
        </Body>
      </Container>
    </Main>
  );
};

export default TrackShare;

const Main = styled.main`
  width: 100%;
  background-color: #0d0d0d;
  height: 100vh;
  position: relative;
  max-height: 1920px;
  max-width: 1920px;
  @media only screen and (max-width: 769px) {
    overflow: hidden;
    width: 100vw;
    height: auto;
  }
`;

const BackGround = styled.div<{ colorb: string; colora: string }>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: ${(props) => (props.colorb ? props.colorb : "transparent")};
  background: ${(props) =>
    `linear-gradient(180deg, ${props.colora} 0%,  #0d0d0d 100%)`};
  opacity: 0.5;
`;

const Container = styled.div`
  width: 100%;
  height: 100%;
  z-index: 1;
  position: relative;
`;
const NavContainer = styled.div`
  height: 7rem;
`;

const Body = styled.div`
  width: 100%;
  padding: 6.8rem 6.4rem;
  height: calc(100% - 7rem);
  display: flex;
  justify-content: space-between;
  position: relative;
  @media only screen and (max-width: 769px) {
    flex-direction: column;
    padding: 2.4rem 2.4rem;
  }
`;
